module.exports = __webpack_public_path__ + "static/media/snake.1f21702e.svg";